import { ActionIdEnum } from "src/app/core/enums/list-layout/action-id-enum";
import { ButtonIdEnum } from "src/app/core/enums/list-layout/button-id-enum";
import { ButtonTypeEnum } from "src/app/core/enums/list-layout/button-type-enum";
import { ColumnTypeEnum } from "src/app/core/enums/list-layout/column-type-enum";
import { AccountingEnvironmentEnum, AccountingSystemEnum } from "src/app/core/models/accounting/account-settings.model";
import { TableConfigurationModel } from "src/app/core/models/table/table-configuration.model";
import { GlobalComponent } from "src/app/global-component";

export class AccountingConfigurationListConfig extends TableConfigurationModel {

    constructor() {
        super();
        this.listTitle = "Accounting Configurations";
        this.pageSizeFilter = [
            { pageSize: GlobalComponent.defaultPagingInfo.pageSize },
            { pageSize: 25 },
            { pageSize: 50 }
        ]
        this.columns = [
            {
                visible: 'true',
                order: 0,
                width: "15px",
                type: ColumnTypeEnum.CheckBox,
            },
            {

                dataFieldName: 'system',
                title: 'System',
                visible: 'true',
                order: 1,
                width: "125px",
                type: ColumnTypeEnum.StatusCustom,
                customStatusText: {
                    type: AccountingSystemEnum,
                    switchOptions: [
                        { case: AccountingSystemEnum.QuickBooks, return: 'Quickbooks' },
                        { case: undefined, return: 'Other' }
                    ]
                }
            },
            {
                dataFieldName: 'environment',
                title: 'Environment',
                visible: 'true',
                order: 2,
                width: "125px",
                type: ColumnTypeEnum.StatusCustom,
                customStatusClass: {
                    type: AccountingEnvironmentEnum,
                    switchOptions: [

                    ]
                },
                customStatusText: {
                    type: AccountingEnvironmentEnum,
                    switchOptions: [
                        { case: AccountingEnvironmentEnum.Development, return: 'Development' },
                        { case: AccountingEnvironmentEnum.Production, return: 'Production' },
                        { case: AccountingEnvironmentEnum.Staging, return: 'Staging' },
                        { case: undefined, return: 'Other' }
                    ]
                }
            },

            {
                dataFieldName: 'clientId',
                title: 'ClientId',
                visible: 'true',

                order: 3,
                width: "150px",
                type: ColumnTypeEnum.String
            },
            {
                dataFieldName: 'clientSecret',
                title: 'Client Secret',
                visible: 'true',

                order: 4,
                width: "150px",
                type: ColumnTypeEnum.String
            },
            {
                dataFieldName: 'redirectUri',
                title: 'Redirect Uri',

                visible: 'true',
                order: 5,
                width: "125px",
                type: ColumnTypeEnum.String
            },
            {
                dataFieldName: 'discoveryDocumentUrl',
                title: 'Discovery Document Url',

                visible: 'true',
                order: 6,
                width: "175px",
                type: ColumnTypeEnum.String
            },
            {
                dataFieldName: 'apiBaseUrl',
                title: 'Api Base Url',

                visible: 'true',
                order: 7,
                width: "125px",
                type: ColumnTypeEnum.String
            },
            {
                title: 'Actions',
                visible: 'true',
                order: 8,
                width: "125px",
                type: ColumnTypeEnum.Action
            },
        ]
        this.filters = undefined;
        this.searchbarFilter = undefined;
        this.actions = [
            {
                visible: 'true',
                label: 'Edit',
                actionId: ActionIdEnum.Edit,
                icon: 'ri-edit-line',
                inDropdown: true,
                inList: false
            },
            {
                visible: 'true',
                label: 'Delete',
                actionId: ActionIdEnum.Delete,
                icon: 'ri-delete-bin-fill',
                inDropdown: true,
                inList: false
            }
        ]
        this.buttons = [{
            visible: 'true',
            label: "Create",
            iconIsAfterLabel: false,
            action: ButtonIdEnum.CreateNew,
            color: "btn-success",
            icon: "ri-add-fill",
            type: ButtonTypeEnum.Default
        },
        {
            visible: 'true',
            label: undefined,
            action: ButtonIdEnum.None,
            color: "btn-soft-secondary",
            iconIsAfterLabel: true,
            icon: "ri-more-2-fill",
            type: ButtonTypeEnum.Dropdown,
            actions: [
                {
                    text: 'Delete Multiple',
                    value: ButtonIdEnum.Delete,
                    color: 'btn-soft-primary',
                    visible: true
                },
            ]
        },],
        this.enablePagination = false;
        this.canConfigBeSavedToServer = true;
    }
}